export default __webpack_public_path__ + "static/media/sliderFull_noThemeSelected.4c499cb9.svg";